export default __webpack_public_path__ + "static/media/Path3512.36bb667c.svg";